import {
    Box,
    Divider,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Chip,
    Container
} from "@mui/material";

import { useEffect, useRef, useState } from "react";
import axios from "axios";

import marketMap from "../../assets/market.jpg";
import config from "../../config.json";
import { ItemsImages } from "../../utils/items-list";

export const MarketPlacePage = () => {
    const apiEndPoint = config.apiEndPoint + "info/marketplace";

    const [result, setResult] = useState([]);
    const [enabled, setEnabled] = useState(false);
    const [posXMg, setPosXMg] = useState(0);
    const [posYMg, setPosYMg] = useState(0);

    const imgRef = useRef();

    useEffect(() => {
        axios
            .get(apiEndPoint)
            .then((response) => response.data)
            .then((data) => setResult(data));
    }, []);

    const mapWidth = 512;
    const mapHeight = 512;

    const hoverItem = (item) => {
        setEnabled(true);

        let posX = parseInt(item.positionX);
        let posY = parseInt(item.positionY);

        const newX = (posX - posY) * 32 + 8192 / 2;
        const newY = (posX + posY - (384 - 1)) * (32 / 2) + 8192 / 2;

        posX = newX * 0.0625;
        posY = newY * 0.0625;

        const elemWidth = imgRef.current.width;
        const elemHeight = imgRef.current.height;

        const scaleWidth = elemWidth / mapWidth;
        const scaleHeight = elemHeight / mapHeight;

        posX *= scaleWidth;
        posY *= scaleHeight;

        posX -= 12.5;
        posY -= 12.5;

        setPosXMg(posX);
        setPosYMg(posY);
    };

    const renderItems = () => (
        <TableContainer
            component={Paper}
            sx={{
                background: "linear-gradient(145deg, rgba(10,25,17,0.98), rgba(5,12,9,0.98))",
                backdropFilter: "blur(18px)",
                border: "1px solid rgba(74,222,128,0.16)",
                borderRadius: "20px",
                boxShadow: "0 20px 55px rgba(0,0,0,0.45)",
                overflow: "auto",

                "&::-webkit-scrollbar": {
                    height: "7px",
                },

                "&::-webkit-scrollbar-track": {
                    background: "#050c08",
                },

                "&::-webkit-scrollbar-thumb": {
                    background: "rgba(74,222,128,0.35)",
                    borderRadius: "10px",
                },
            }}
        >
            <Table
                stickyHeader
                sx={{
                    minWidth: 850,
                    borderCollapse: "separate",
                    borderSpacing: "0 3px",
                }}
            >
                <TableHead>
                    <TableRow>
                        {[
                            "Item",
                            "Quality",
                            "Plus",
                            "Gem 1",
                            "Gem 2",
                            "Seller",
                            "Price"
                        ].map((h, i) => (
                            <TableCell
                                key={i}
                                sx={{
                                    background: "linear-gradient(180deg, #102219, #09140e)",
                                    color: "#4ade80",
                                    fontWeight: 900,
                                    fontSize: "10px",
                                    letterSpacing: "1.5px",
                                    textTransform: "uppercase",
                                    borderBottom: "1px solid rgba(74,222,128,0.18)",
                                    py: 2.2,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {h}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {result.map((item, index) => (
                        <TableRow
                            key={index}
                            hover
                            onMouseEnter={() => hoverItem(item)}
                            onMouseLeave={() => setEnabled(false)}
                            sx={{
                                background: "rgba(255,255,255,0.012)",
                                transition: "all 0.22s ease",

                                "&:hover": {
                                    background: "linear-gradient(90deg, rgba(74,222,128,0.09), rgba(74,222,128,0.02))",
                                },

                                "& td": {
                                    borderBottom: "1px solid rgba(255,255,255,0.035)",
                                },
                            }}
                        >
                            {/* ITEM */}
                            <TableCell
                                sx={{
                                    py: 1.8,
                                    minWidth: 230,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={`/items/${ItemsImages.get(item.itemId?.toString()) ?? ItemsImages.get("Default")}`}
                                        sx={{
                                            width: 44,
                                            height: 44,
                                            borderRadius: "11px",
                                            background: "linear-gradient(145deg, #14251a, #08110b)",
                                            border: "1px solid rgba(74,222,128,0.16)",
                                            p: 0.5,
                                            objectFit: "contain",
                                            transition: "all 0.25s ease",
                                        }}
                                    />

                                    <Box
                                        sx={{
                                            minWidth: 0,
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#eee",
                                                fontWeight: 800,
                                                fontSize: "13px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {item.itemName}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#557060",
                                                fontSize: "10px",
                                                mt: 0.3,
                                                letterSpacing: "0.8px",
                                            }}
                                        >
                                            MARKET ITEM
                                        </Typography>
                                    </Box>
                                </Box>
                            </TableCell>

                            {/* QUALITY */}
                            <TableCell
                                sx={{
                                    color: "#ccc",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                <Chip
                                    label={item.quality || "Fixed"}
                                    size="small"
                                    sx={{
                                        height: 27,
                                        background: "rgba(74,222,128,0.10)",
                                        border: "1px solid rgba(74,222,128,0.22)",
                                        color: "#4ade80",
                                        fontWeight: 800,
                                        fontSize: "10px",
                                        "& .MuiChip-label": {
                                            px: 1.3,
                                        },
                                    }}
                                />
                            </TableCell>

                            {/* PLUS */}
                            <TableCell
                                sx={{
                                    color: "#4ade80",
                                    fontWeight: 900,
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                +{item.plus}
                            </TableCell>

                            {/* GEM 1 */}
                            <TableCell
                                sx={{
                                    color: item.gem1 ? "#aaa" : "#444",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                }}
                            >
                                {item.gem1 || "-"}
                            </TableCell>

                            {/* GEM 2 */}
                            <TableCell
                                sx={{
                                    color: item.gem2 ? "#aaa" : "#444",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                }}
                            >
                                {item.gem2 || "-"}
                            </TableCell>

                            {/* SELLER */}
                            <TableCell
                                sx={{
                                    color: "#eee",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {item.seller}
                            </TableCell>

                            {/* PRICE */}
                            <TableCell
                                sx={{
                                    color: "#4ade80",
                                    fontWeight: 900,
                                    fontSize: "13px",
                                    whiteSpace: "nowrap",
                                    textShadow: "0 0 12px rgba(74,222,128,0.12)",
                                }}
                            >
                                {item.price?.toLocaleString()}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {result.length === 0 && (
                <Box
                    sx={{
                        py: 8,
                        textAlign: "center",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#789080",
                            fontWeight: 700,
                            fontSize: "14px",
                        }}
                    >
                        No marketplace items available
                    </Typography>

                    <Typography
                        sx={{
                            color: "#46584b",
                            fontSize: "11px",
                            mt: 1,
                        }}
                    >
                        The marketplace is currently empty.
                    </Typography>
                </Box>
            )}
        </TableContainer>
    );

    const renderMap = () => (
        <Box
            sx={{
                position: "relative",
                borderRadius: "18px",
                overflow: "hidden",
                border: "1px solid rgba(74,222,128,0.16)",
                background: "#050c08",
                boxShadow: "0 15px 40px rgba(0,0,0,0.45)",
            }}
        >
            {/* MAP MARKER */}
            {enabled && (
                <Box
                    sx={{
                        position: "absolute",
                        top: posYMg,
                        left: posXMg,
                        zIndex: 5,
                        pointerEvents: "none",
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            border: "3px solid #4ade80",
                            background: "rgba(74,222,128,0.28)",
                            animation: "pulse 1.5s infinite",
                            boxShadow: "0 0 18px rgba(74,222,128,0.5)",

                            "@keyframes pulse": {
                                "0%": {
                                    transform: "scale(0.8)",
                                    opacity: 1,
                                },
                                "100%": {
                                    transform: "scale(2.2)",
                                    opacity: 0,
                                },
                            },
                        }}
                    />
                </Box>
            )}

            {/* MAP IMAGE */}
            <Box
                component="img"
                ref={imgRef}
                src={marketMap}
                sx={{
                    width: "100%",
                    display: "block",
                    minHeight: {
                        xs: 300,
                        md: 420,
                    },
                    objectFit: "cover",
                }}
            />

            {/* MAP OVERLAY */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(to top, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.15) 45%, transparent 75%)",
                    pointerEvents: "none",
                }}
            />

            {/* MAP TOP BADGE */}
            <Box
                sx={{
                    position: "absolute",
                    top: 18,
                    left: 18,
                    px: 1.5,
                    py: 0.7,
                    borderRadius: "9px",
                    background: "rgba(5,15,9,0.82)",
                    border: "1px solid rgba(74,222,128,0.2)",
                    backdropFilter: "blur(8px)",
                }}
            >
                <Typography
                    sx={{
                        color: "#4ade80",
                        fontSize: "9px",
                        fontWeight: 900,
                        letterSpacing: "1.5px",
                    }}
                >
                    LIVE MAP
                </Typography>
            </Box>

            {/* MAP INFORMATION */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 20,
                    left: 20,
                    right: 20,
                }}
            >
                <Typography
                    sx={{
                        color: "#4ade80",
                        fontWeight: 900,
                        fontSize: "20px",
                        textShadow: "0 2px 10px rgba(0,0,0,0.7)",
                    }}
                >
                    Market Map
                </Typography>

                <Typography
                    sx={{
                        color: "#ccc",
                        fontSize: 12,
                        mt: 0.5,
                    }}
                >
                    Hover items to locate sellers
                </Typography>

                <Box
                    sx={{
                        width: 45,
                        height: 2,
                        background: "linear-gradient(90deg, #4ade80, transparent)",
                        mt: 1.5,
                    }}
                />
            </Box>
        </Box>
    );

    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: { xs: 5, sm: 7, md: 10 },
                position: "relative",
                overflow: "hidden",
                background: "radial-gradient(circle at 50% -10%, rgba(34,197,94,0.16), transparent 35%), radial-gradient(circle at 100% 50%, rgba(34,197,94,0.04), transparent 30%), linear-gradient(180deg, #030805 0%, #07100a 55%, #020503 100%)",
                color: "#fff",

                "&:before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "65%",
                    height: "1px",
                    background: "linear-gradient(90deg, transparent, rgba(74,222,128,0.8), transparent)",
                },
            }}
        >
            {/* BACKGROUND GLOW */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-250px",
                    right: "-250px",
                    width: 650,
                    height: 650,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(34,197,94,0.10) 0%, transparent 68%)",
                    filter: "blur(110px)",
                    pointerEvents: "none",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    bottom: "-300px",
                    left: "-300px",
                    width: 700,
                    height: 700,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(34,197,94,0.045) 0%, transparent 68%)",
                    filter: "blur(120px)",
                    pointerEvents: "none",
                }}
            />

            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        textAlign: "center",
                        mb: {
                            xs: 5,
                            md: 7,
                        },
                    }}
                >
                    <Typography
                        sx={{
                            color: "#4ade80",
                            letterSpacing: "4px",
                            fontWeight: 800,
                            fontSize: "11px",
                            mb: 1.5,
                            textTransform: "uppercase",
                            textShadow: "0 0 20px rgba(74,222,128,0.15)",
                        }}
                    >
                        Critical Conquer • LIVE MARKET
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: "40px",
                                sm: "50px",
                                md: "62px",
                            },
                            fontWeight: 900,
                            lineHeight: 1,
                            letterSpacing: "-1px",
                            color: "#fff",
                            mb: 2.5,
                            textShadow: "0 5px 30px rgba(0,0,0,0.55)",
                        }}
                    >
                        Marketplace
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.55)",
                            maxWidth: 700,
                            mx: "auto",
                            fontSize: {
                                xs: "14px",
                                md: "16px",
                            },
                            lineHeight: 1.8,
                        }}
                    >
                        Browse items being sold by players,
                        check equipment details, and locate
                        sellers around the market in real time.
                    </Typography>

                    {/* DECORATIVE LINE */}
                    <Box
                        sx={{
                            width: 90,
                            height: 3,
                            borderRadius: "10px",
                            background: "linear-gradient(90deg, transparent, #4ade80, transparent)",
                            mx: "auto",
                            mt: 3,
                        }}
                    />
                </Box>

                {/* MARKET CONTENT */}
                <Grid
                    container
                    spacing={{
                        xs: 3,
                        md: 4,
                    }}
                    alignItems="stretch"
                >
                    {/* ITEMS */}
                    <Grid item xs={12} lg={8}>
                        <Paper
                            elevation={0}
                            sx={{
                                height: "100%",
                                p: {
                                    xs: 1.5,
                                    sm: 2,
                                    md: 2.5,
                                },
                                background: "linear-gradient(145deg, rgba(10,25,17,0.98), rgba(5,12,9,0.98))",
                                border: "1px solid rgba(74,222,128,0.16)",
                                borderRadius: {
                                    xs: "20px",
                                    md: "24px",
                                },
                                boxShadow: "0 25px 65px rgba(0,0,0,0.5)",
                                position: "relative",
                                overflow: "hidden",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "2px",
                                    background: "linear-gradient(90deg, transparent, #16a34a, #86efac, #16a34a, transparent)",
                                },
                            }}
                        >
                            {/* SECTION HEADER */}
                            <Box
                                sx={{
                                    px: {
                                        xs: 1,
                                        sm: 1.5,
                                    },
                                    pt: 1,
                                    pb: 2.5,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#4ade80",
                                        fontSize: "11px",
                                        fontWeight: 800,
                                        letterSpacing: "2px",
                                        textTransform: "uppercase",
                                        mb: 0.7,
                                    }}
                                >
                                    PLAYER TRADING
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontSize: {
                                            xs: "24px",
                                            md: "30px",
                                        },
                                        fontWeight: 900,
                                        lineHeight: 1.1,
                                    }}
                                >
                                    Items For Sale
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#718078",
                                        fontSize: "12px",
                                        mt: 0.8,
                                    }}
                                >
                                    Browse the latest marketplace listings.
                                </Typography>
                            </Box>

                            {renderItems()}
                        </Paper>
                    </Grid>

                    {/* MAP */}
                    <Grid item xs={12} lg={4}>
                        <Paper
                            elevation={0}
                            sx={{
                                height: "100%",
                                p: {
                                    xs: 1.5,
                                    sm: 2,
                                    md: 2.5,
                                },
                                background: "linear-gradient(145deg, rgba(10,25,17,0.98), rgba(5,12,9,0.98))",
                                border: "1px solid rgba(74,222,128,0.16)",
                                borderRadius: {
                                    xs: "20px",
                                    md: "24px",
                                },
                                boxShadow: "0 25px 65px rgba(0,0,0,0.5)",
                                position: "relative",
                                overflow: "hidden",

                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    height: "2px",
                                    background: "linear-gradient(90deg, transparent, #16a34a, #86efac, #16a34a, transparent)",
                                },
                            }}
                        >
                            {/* SECTION HEADER */}
                            <Box
                                sx={{
                                    px: {
                                        xs: 1,
                                        sm: 1.5,
                                    },
                                    pt: 1,
                                    pb: 2.5,
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#4ade80",
                                        fontSize: "11px",
                                        fontWeight: 800,
                                        letterSpacing: "2px",
                                        textTransform: "uppercase",
                                        mb: 0.7,
                                    }}
                                >
                                    SELLER LOCATION
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontSize: {
                                            xs: "24px",
                                            md: "30px",
                                        },
                                        fontWeight: 900,
                                        lineHeight: 1.1,
                                    }}
                                >
                                    Market Map
                                </Typography>

                                <Typography
                                    sx={{
                                        color: "#718078",
                                        fontSize: "12px",
                                        mt: 0.8,
                                    }}
                                >
                                    Hover an item to find its seller.
                                </Typography>
                            </Box>

                            {renderMap()}
                        </Paper>
                    </Grid>
                </Grid>

                {/* BOTTOM DECORATION */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mt: 5,
                        gap: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background: "linear-gradient(90deg, transparent, rgba(74,222,128,0.25))",
                        }}
                    />

                    <Typography
                        sx={{
                            color: "#46584b",
                            fontSize: "10px",
                            fontWeight: 700,
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                        }}
                    >
                        Critical Conquer
                    </Typography>

                    <Box
                        sx={{
                            width: {
                                xs: 45,
                                sm: 70,
                            },
                            height: "1px",
                            background: "linear-gradient(90deg, rgba(74,222,128,0.25), transparent)",
                        }}
                    />
                </Box>
            </Container>
        </Box>
    );
};